import React from 'react';
import './Grid.css';

export const Row = ({ children, className = '', ...props }) => {
  return (
    <div className={`row ${className}`} {...props}>
      {children}
    </div>
  );
};

export const Col = ({ 
  children, 
  xs, sm, md, lg, xl,
  className = '',
  ...props 
}) => {
  const colClasses = [];
  
  if (xs) colClasses.push(`col-${xs}`);
  if (sm) colClasses.push(`col-sm-${sm}`);
  if (md) colClasses.push(`col-md-${md}`);
  if (lg) colClasses.push(`col-lg-${lg}`);
  if (xl) colClasses.push(`col-xl-${xl}`);
  
  if (colClasses.length === 0) colClasses.push('col');
  
  return (
    <div className={`${colClasses.join(' ')} ${className}`} {...props}>
      {children}
    </div>
  );
};